import React from 'react';
import Header from './Header';

const BaseContainer = (props) => {
    const { isTmpCont, sidebar } = props;
    return (
        <>
            <Header isTmpCont={isTmpCont} sidebar={sidebar}>
                {props.children}
            </Header>
        </>
    )
};

export default BaseContainer;
